import { render } from "./Home.vue?vue&type=template&id=36eedf4f"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=36eedf4f&lang=css"

import exportComponent from "/Users/qilei/Desktop/other/dingcan4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__